export enum PAYMENT_STATUS {
  NOT_INITILIZED = "NOT_INITILIZED",
  INITIALIZED = "INITIALIZED",
  PAY_SUCCESS = "PAY_SUCCESS",
  PAY_CLOSED = "PAY_CLOSED",
}
